<template>
  <div class="main_input">
    <div class="upload_file border_animation">
      <input
        type="file"
        ref="fileInput"
        :id="for_id"
        :accept="accept"
        @change="handleFileChange"
        :disabled="disabled"
        :multiple="multiple"
      />
      <label class="uploadphoto d-flex justify-content-center" :for="for_id">
        <img
          src="@/assets/media/images/upload_image.svg"
          alt="Image To Upload"
          width="100"
          height="100"
          class="image_placeholder"
        />
      </label>
    </div>

    <div class="file-container">
      <div
        v-for="(item, idx) in localFiles"
        :key="item.id || item.url || item.file?.name || idx"
        class="box_file"
      >
        <img v-if="isImage(item)" :src="item.url" alt="Preview" />
        <video v-else-if="isVideo(item)" :src="item.url" controls />
        <div v-else class="file-fallback">
          sadas <font-awesome-icon icon="file" />
          <span>{{ displayName(item) }}</span>
        </div>

        <button
          class="remove-button"
          @click="removeFile(idx, item.id)"
          :disabled="disabled || localFiles.length <= 1"
          v-if="!disabled && localFiles.length > 1"
          title="Remove"
        >
          ✕
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LazyFileUploader",
  props: {
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    content: { type: String, default: "" },
    for_id: { type: String, default: "" },
    files: { type: Array, default: () => [] },
    accept: { type: String, default: "image/*" },
  },
  data() {
    return {
      localFiles: [...this.files],
    };
  },
  watch: {
    files: {
      immediate: true,
      handler(newFiles) {
        this.localFiles = [...newFiles];
      },
    },
  },
  methods: {
    handleFileChange() {
      const input = this.$refs.fileInput;
      const picked = Array.from(input.files);
      const patterns = this.accept
        .split(",")
        .map((s) => s.trim())
        .filter((s) => s);

      const valids = [];
      for (const file of picked) {
        if (!this.isValid(file, patterns)) {
          this.$iziToast.error({
            timeout: 3000,
            position: "topRight",
            message: `Invalid file type: ${file.name}`,
          });
        } else {
          valids.push(file);
          if (!this.multiple) break;
        }
      }

      if (valids.length) {
        if (this.multiple) {
          valids.forEach((file) => {
            this.localFiles.push({
              type: file.type,
              file,
              url: URL.createObjectURL(file),
            });
          });
        } else {
          const file = valids[0];
          console.log(file);

          this.localFiles = [
            { type: file.type, file, url: URL.createObjectURL(file) },
          ];
        }
        this.$emit("change", this.localFiles);
      }
      input.value = "";
    },

    isValid(file, patterns) {
      return patterns.some((pat) => {
        if (pat.startsWith(".")) {
          return file.name.toLowerCase().endsWith(pat.toLowerCase());
        }
        if (pat.endsWith("/*")) {
          return file.type.startsWith(pat.slice(0, -1));
        }
        return file.type === pat;
      });
    },

    setFiles(list) {
      this.localFiles = list.map((item) => ({
        id: item?.id || null,
        url: item?.url,
        file: item?.file || null,
      }));
      this.$emit("change", this.localFiles);
    },

    async removeFile(idx, id) {
      const removed = this.localFiles.splice(idx, 1)[0];
      if (removed?.url?.startsWith("blob:")) {
        URL.revokeObjectURL(removed.url);
      }

      if (id) {
        try {
          const res = await this.$axios({
            url: `ads/${this.$route.params.id}/images/${id}`,
            method: "DELETE",
          });
          console.log();
          this.$message.success(res.data.message);
        } catch (e) {
          console.log(e);
          this.$iziToast.error({
            timeout: 3000,
            position: "topRight",
            message: e.response?.data?.message || "Delete failed",
          });
        }
      }
      this.$emit("change", this.localFiles);
    },

    getFiles() {
      return this.localFiles;
    },

    isImage(item) {
      if (item?.type) {
        return item.type.startsWith("image/");
      }
      return /\.(jpe?g|png|gif|webp|svg|jfif)$/i.test(item.url);
    },

    isVideo(item) {
      if (item?.type) {
        return item?.type.startsWith("video/");
      }
      return /\.(mp4|webm|ogg)$/i.test(item.url);
    },

    displayName(item) {
      if (item.file) return item.file.name;
      return item.url.split("/").pop().split("?")[0];
    },
  },
};
</script>

<style scoped lang="scss">
.main_input {
  margin-bottom: 25px;
}

.upload_file {
  input[type="file"] {
    display: none;
  }
  label {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }
}

.file-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 12px;

  .box_file {
    position: relative;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    width: 160px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;

    img,
    video {
      max-width: 100%;
      max-height: 100%;
    }

    .file-fallback {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #666;
      font-size: 0.9em;
      svg {
        font-size: 1.4em;
      }
    }

    .remove-button {
      position: absolute;
      top: 0;
      right: 0;
      background-color: red;
      color: white;
      border: none;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      padding: 2px 0;

      &:hover {
        color: darkred;
        border: 1px solid darkred;
        background: #fff;
      }
    }
  }
}
</style>
